// Shared number/currency formatters for the Automated Trading module.
//
// These mirror the Maghaweer Portfolio v2 formatters, with ONE deliberate change: the
// P&L colour classes follow GreenSkew's house rule (signClass in DashboardUI) — a darker
// 700-weight green/red for the LIGHT default theme, lightening to 400 in dark. Maghaweer's
// flat `text-green-400` is too pale to read on this portal's white background.

export const fmt$ = (n, d = 0) =>
  n == null || isNaN(n) ? '—'
    : new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: d, maximumFractionDigits: d }).format(n);

export const signed$ = (n, d = 0) => (n == null || isNaN(n) ? '—' : `${n >= 0 ? '+' : ''}${fmt$(n, d)}`);

export const fmtPct = (n, d = 1) => (n == null || isNaN(n) ? '—' : `${n >= 0 ? '+' : ''}${n.toFixed(d)}%`);

// Like fmtPct but with NO leading "+" on positives — a bare number, and a minus only when
// negative ("6.15%", "-2.30%"). Used where green/red colour already carries direction
// (Return / SPX / Alpha in the portfolio list), so a "+" would be redundant noise.
export const fmtPctNeg = (n, d = 1) => (n == null || isNaN(n) ? '—' : `${n.toFixed(d)}%`);

// "6 September 2026" — day-first (the readers here are not American) and spelled out so a dateline
// is unambiguous at a glance. Shared by the list dateline and the account detail, so the two
// cannot format the same "As at" differently.
export const fmtDate = (s) => (s ? new Date(s).toLocaleDateString('en-GB',
  { day: 'numeric', month: 'long', year: 'numeric' }) : '—');

// "23 Jun 2026" — the compact variant, for tight inline datelines like a basket's since-date
// where the full spelled-out month would crowd the row. Same day-first, non-American ordering.
export const fmtDateShort = (s) => (s ? new Date(s).toLocaleDateString('en-GB',
  { day: 'numeric', month: 'short', year: 'numeric' }) : '—');

// Green up, red down — legible on both themes (700 on light, 400 on dark).
export const pnlClr = (n) =>
  n == null || isNaN(n) ? 'text-gray-400'
    : n > 0 ? 'text-green-700 dark:text-green-400'
      : n < 0 ? 'text-red-700 dark:text-red-400'
        : 'text-gray-500 dark:text-gray-400';
